module.exports = __webpack_public_path__ + "img/apply_off.f2c1c1d4.svg";